import { render, staticRenderFns } from "./PushForwardProducts.vue?vue&type=template&id=2763edc9&"
import script from "./PushForwardProducts.vue?vue&type=script&lang=js&"
export * from "./PushForwardProducts.vue?vue&type=script&lang=js&"
import style0 from "./PushForwardProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports